import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container bg-dCard max-w-xl m-auto rounded-lg shadow-xl p-5 text-2xl font-mono mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-dDollar" }, "Welcome, ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
      class: "text-dInput bg-dBg rounded-md p-3",
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
    }, null, 544), [
      [_vModelText, _ctx.input]
    ])
  ]))
}